import * as React from 'react';
import Wizard, {Step, StepHeadRenderFn} from '../../components/Wizard';
import {css} from 'emotion';
import StepTitle from './private/RegistrationWizardStepTitle';
import CurrentHead from './private/RegistrationWizardCurrentStepHead';
import {RegistrationWizardProps} from './types';
import mq from '../../utils/mq';
import {hideVisually} from 'polished';

export default class RegistrationWizard extends React.Component<RegistrationWizardProps, {}> {
  public static Step = Step;

  public render() {
    return (
      <Wizard
        stepTitle={({status, title}) => <StepTitle status={status} title={title} />}
        customClassName={this._customClassName}
        stepHeads={{processing: this._renderCurrentHead}}
        getStepNumber={this._getStepNumber}
        vertical={true}
        dot={true}
        {...this.props}
      />
    );
  }

  private get _customClassName() {
    return {
      main: css({
        flexGrow: 1,
        [mq('laptop')]: {
          paddingLeft: 80
        },
        [mq('desktop')]: {
          paddingLeft: 100
        }
      }),
      connector: css({
        [mq('phone')]: hideVisually(),
        [mq('tablet')]: hideVisually(),
        [mq('laptopAndUp')]: {
          width: 60
        }
      })
    };
  }

  private _getStepNumber = (index: number) => (index < 10 ? `0${index + 1}` : index + 1);

  private _renderCurrentHead: StepHeadRenderFn = ({stepNumber}) => {
    return <CurrentHead>{stepNumber}</CurrentHead>;
  };
}



// WEBPACK FOOTER //
// ./src/containers/RegistrationWizard/RegistrationWizard.tsx